module DateTime.Format where

import Prelude

import Data.DateTime (DateTime(..))
import Data.JSDate (JSDate)
import Data.JSDate as JSD

foreign import _formatJsDate :: JSDate -> String

formatDateTimeLocally :: DateTime -> String
formatDateTimeLocally dt = _formatJsDate $ JSD.fromDateTime dt

